import type { PlannerMode } from "../../store/uiStore";

/**
 * Phones get their own trip board (toolbar, Filters dialog, results card) in
 * place of the Sidebar and Map drawers. Phrased as max-width so that a
 * missing matchMedia falls back to the drawer layout.
 */
export const PHONE_LAYOUT_QUERY = "(max-width: 47.99rem)";

/**
 * The phone Planner has no month Calendar view. A Calendar choice made on a
 * wider layout shows All days there and returns when the layout widens.
 */
export function phonePlannerMode(mode: PlannerMode): PlannerMode {
  return mode === "calendar" ? "all" : mode;
}
